import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import React from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import { GraphColors } from '../../../common/helper';

const getCustomText = (dataKey: any) => {
  const textMapping = {
    key1: 'Custom Text 1',
    key2: 'Custom Text 2',
    key3: 'Custom Text 3',
    // Add more mappings as needed
  };
  return textMapping;
};

const MedalLegend = () => (
  <Box
    className='flex_start'
    sx={{
      justifyContent: 'center',
    }}
  >
    {['금', '은', '동'].map((entry, idx) => {
      const customText = getCustomText(entry); // Replace with your custom mapping function
      return (
        <Box key={`legend_key_${idx}`}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              pr: '15px',
            }}
          >
            <CircleIcon
              sx={{
                fontSize: '15px',
                marginRight: '5px',
                color: GraphColors[idx],
              }}
            />
            <Box className='circle_legend'>{entry}</Box>
          </Box>
        </Box>
      );
    })}
  </Box>
);

export default MedalLegend;
